import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

import { IBroadcast, IBroadcastResponse, IContentDeliveryRequest, IQuickContentBrodacast, IQuickScreenPlaylistBrodacast, IQuickSchedulePlaylistDetailsResponse, IResponseMessage, IScheduleConflictValidationResponse } from '../../models';
import { APIConstants } from '../../common';

@Injectable({
  providedIn: 'root'
})
export class BroadcastService {

  constructor(private http: HttpClient) { }

  getAllBroadcast(type?: string): Observable<IBroadcastResponse> {
    if (!type || type === 'Total') {
      return this.http.get<IBroadcastResponse>(APIConstants.broadcast);
    } else {
      const url = APIConstants.broadcast + '?type=' + type.toLowerCase();
      return this.http.get<IBroadcastResponse>(url);
    }
  }

  getAllBroadcastByLimit(limit: number, offset: number, type?: string, search?: string, ordering?: string): Observable<IBroadcastResponse> {
    let url = APIConstants.broadcast + '?limit=' + limit + '&offset=' + offset;
    if (type && type !== 'Total') {
        url += '&type=' + type.toLowerCase();
    }
    if (search) {
        url += '&search=' + encodeURIComponent(search);
    }
    if (ordering) {
        url += '&ordering=' + encodeURIComponent(ordering);
    }
    return this.http.get<IBroadcastResponse>(url);
  }

  getScheduleCountList(): Observable<any> {
    return this.http.get<any>(APIConstants.scheduleCountList);
  }

  addBroadcast(broadcast: FormData): Observable<IBroadcast> {
    return this.http.post<IBroadcast>(APIConstants.broadcast, broadcast);
  }

  updateBroadcast(broadcast_id: number, broadcast: FormData): Observable<IBroadcast> {
    return this.http.put<IBroadcast>(APIConstants.broadcast + broadcast_id + '/', broadcast);
  }

  deleteBroadcastById(broadcast_id: number): Observable<IResponseMessage> {
    return this.http.delete<IResponseMessage>(APIConstants.broadcast + broadcast_id + '/');
  }

  getBroadcastById(broadcast_id: number): Observable<IBroadcast> {
    return this.http.get<IBroadcast>(APIConstants.broadcast + broadcast_id + '/');
  }

  getBroadcastByScreenId(screen_id: number): Observable<IBroadcast[]> {
    return this.http.get<IBroadcast[]>(APIConstants.broadcastByScreens + screen_id + '/');
  }

  getBroadcastByCompositionId(composition_id: number): Observable<IBroadcast[]> {
    return this.http.get<IBroadcast[]>(APIConstants.broadcastByComposition + composition_id + '/');
  }

  checkPlannedBrodcastConflict(broadcast: IBroadcast): Observable<IScheduleConflictValidationResponse> {
    return this.http.post<IScheduleConflictValidationResponse>(APIConstants.checkPlannedBrodcastConflict, broadcast);
  }

  checkQuickBrodcastConflict(quickContentData: IContentDeliveryRequest): Observable<IScheduleConflictValidationResponse> {
    return this.http.post<IScheduleConflictValidationResponse>(APIConstants.checkQuickBrodcastConflict, quickContentData);
  }

  createQuickContentBroadcast(quickContentData: IContentDeliveryRequest): Observable<IResponseMessage> {
    return this.http.post<IResponseMessage>(APIConstants.quickContentBroadcast, quickContentData);
  }

  getQuickSchedulePlaylistDetails(screen_id: number, broadcast_id: number): Observable<IQuickSchedulePlaylistDetailsResponse> {
    return this.http.post<IQuickSchedulePlaylistDetailsResponse>(APIConstants.quickScheduleAddPlaylistDetails, { screen_id, broadcast_id });
  }

  createQuickScreenPlaylistBroadcast(quickScreenPlaylistData: IQuickScreenPlaylistBrodacast): Observable<IResponseMessage> {
    return this.http.post<IResponseMessage>(APIConstants.quickScreenPlaylistBroadcast, quickScreenPlaylistData);
  }



  deleteMultipleBroadcasts(broadcast_ids: number[]): Observable<IResponseMessage> {
    const options = {
      body: { broadcast_ids: broadcast_ids }
    };

    return this.http.delete<IResponseMessage>(APIConstants.deleteMultipleBroadcasts, options);
  }

}
